import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class TrailerTypes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/trailertypes' title='Remorque - Types de remorques' editTitle='Type de remorques' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default TrailerTypes;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailerTypes.js
 **/